module.exports = __webpack_public_path__ + "img/facebook-app-logo.d96467f3.svg";